export type Metodo = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';
export type ValorQuery = string | number | boolean | null | undefined;

export interface Peticion {
  metodo: Metodo;
  /** Ruta relativa a /api/a (p. ej. "/trabajos/123"). Ignorada si viene `url`. */
  ruta: string;
  /** URL completa o relativa al origen (SVG normalizado, rasters). */
  url?: string;
  query?: Record<string, ValorQuery>;
  cuerpo?: unknown;
  respuesta?: 'json' | 'texto' | 'blob';
}

export type Transporte = (p: Peticion) => Promise<unknown>;

export class ErrorApi extends Error {
  constructor(mensaje: string, public status: number, public codigo?: string) {
    super(mensaje);
    this.name = 'ErrorApi';
  }
}

type ObtenerToken = () => Promise<string | null>;
let obtenerToken: ObtenerToken = async () => 'dev';

/** Lo llama el proveedor de sesión (Clerk o modo desarrollo). */
export function configurarToken(fn: ObtenerToken) {
  obtenerToken = fn;
}

export const BASE_API = (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/$/, '') ?? '';

export function construirQuery(q?: Record<string, ValorQuery>): string {
  if (!q) return '';
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v === undefined || v === null || v === '') continue;
    p.set(k, typeof v === 'boolean' ? (v ? '1' : '0') : String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}

export const transporteHttp: Transporte = async (p) => {
  const url = p.url ?? `${BASE_API}/api/a${p.ruta}${construirQuery(p.query)}`;
  const headers: Record<string, string> = { Accept: p.respuesta === 'blob' ? '*/*' : 'application/json' };
  // Sólo mandamos el token a nuestra propia api de admin.
  const esAdmin = !p.url || p.url.startsWith(`${BASE_API}/api/a/`) || p.url.startsWith('/api/a/');
  if (esAdmin) {
    const token = await obtenerToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  if (p.cuerpo !== undefined) headers['Content-Type'] = 'application/json';
  let r: Response;
  try {
    r = await fetch(url, { method: p.metodo, headers, body: p.cuerpo === undefined ? undefined : JSON.stringify(p.cuerpo) });
  } catch {
    throw new ErrorApi('No hay conexión con el servidor.', 0, 'red');
  }
  if (!r.ok) {
    let mensaje = `Error ${r.status}`;
    let codigo: string | undefined;
    try {
      const d = (await r.json()) as { error?: string; codigo?: string };
      if (d.error) mensaje = d.error;
      codigo = d.codigo;
    } catch { /* cuerpo no JSON */ }
    if (r.status === 401) mensaje = 'Tu sesión expiró. Vuelve a entrar.';
    if (r.status === 403 && mensaje.startsWith('Error')) mensaje = 'No tienes permiso para esto.';
    throw new ErrorApi(mensaje, r.status, codigo);
  }
  if (p.respuesta === 'texto') return r.text();
  if (p.respuesta === 'blob') return r.blob();
  if (r.status === 204) return null;
  const texto = await r.text();
  return texto ? JSON.parse(texto) : null;
};

export const MODO_MOCK = import.meta.env.VITE_MOCK === '1' || import.meta.env.VITE_MOCK === 'true';
